(function () {
  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function readJson(key, fallback) {
    try {
      var raw = window.localStorage.getItem(key);
      return raw ? JSON.parse(raw) : fallback;
    } catch (error) {
      return fallback;
    }
  }

  function writeJson(key, value) {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      return false;
    }
    return true;
  }

  function formatNumber(value) {
    return Number(value || 0).toLocaleString();
  }

  function formatPercent(value) {
    return (Math.round(value * 10) / 10).toFixed(1) + "%";
  }

  var liveVotingEndpoint = "https://blpekbnjoipgqpltqygx.supabase.co/functions/v1/dao-location-vote";
  var liveVotingAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJscGVrYm5qb2lwZ3FwbHRxeWd4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODMzOTg2MDUsImV4cCI6MjA5ODk3NDYwNX0.BeAt1a2712gFlrw-cS-3FOq2N3NmhIi_TgVXZPtA_WA";

  function slugify(value) {
    return String(value || "")
      .trim()
      .toLowerCase()
      .replace(/&/g, " and ")
      .replace(/[^a-z0-9\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-")
      .replace(/^-|-$/g, "");
  }

  function makeSessionId() {
    var randomPart = "";
    if (window.crypto && window.crypto.getRandomValues) {
      var values = new Uint32Array(4);
      window.crypto.getRandomValues(values);
      randomPart = toArray(values).map(function (value) {
        return value.toString(16);
      }).join("");
    } else {
      randomPart = Math.random().toString(16).slice(2) + Math.random().toString(16).slice(2);
    }
    return "dao-" + Date.now().toString(36) + "-" + randomPart;
  }

  function getSessionId() {
    var key = "dao:location-voter-session";
    try {
      var existing = window.localStorage.getItem(key);
      if (existing) return existing;
      var created = makeSessionId();
      window.localStorage.setItem(key, created);
      return created;
    } catch (error) {
      return makeSessionId();
    }
  }

  function liveVotingHeaders() {
    return {
      Authorization: "Bearer " + liveVotingAnonKey,
      apikey: liveVotingAnonKey,
      "Content-Type": "application/json"
    };
  }

  function readSessionJson(key, fallback) {
    try {
      var raw = window.sessionStorage.getItem(key);
      return raw ? JSON.parse(raw) : fallback;
    } catch (error) {
      return fallback;
    }
  }

  function writeSessionJson(key, value) {
    try {
      window.sessionStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      return false;
    }
    return true;
  }

  function initReveals(root) {
    var revealEls = toArray(root.querySelectorAll(".dao-locations-reveal"));
    if (!revealEls.length) return;

    var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduceMotion || !("IntersectionObserver" in window)) {
      revealEls.forEach(function (el) {
        el.classList.add("is-visible");
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.14 });

    revealEls.forEach(function (el) {
      observer.observe(el);
    });
  }

  var malaysiaTimeFormatter = null;

  function getMalaysiaMinutes(date) {
    if (!malaysiaTimeFormatter && window.Intl && Intl.DateTimeFormat) {
      malaysiaTimeFormatter = new Intl.DateTimeFormat("en-GB", {
        timeZone: "Asia/Kuala_Lumpur",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false
      });
    }

    if (!malaysiaTimeFormatter || !malaysiaTimeFormatter.formatToParts) {
      var fallback = date || new Date();
      return ((fallback.getUTCHours() * 60 + fallback.getUTCMinutes() + (8 * 60)) % 1440);
    }

    var hour = 0;
    var minute = 0;
    malaysiaTimeFormatter.formatToParts(date || new Date()).forEach(function (part) {
      if (part.type === "hour") hour = Number(part.value);
      if (part.type === "minute") minute = Number(part.value);
    });

    if (hour === 24) hour = 0;
    return (hour * 60) + minute;
  }

  function parseTimeMinutes(value) {
    var match = String(value || "").match(/^(\d{1,2}):(\d{2})$/);
    if (!match) return null;
    var hour = Number(match[1]);
    var minute = Number(match[2]);
    if (hour < 0 || hour > 23 || minute < 0 || minute > 59) return null;
    return (hour * 60) + minute;
  }

  function readLocationStatus(card, malaysiaMinutes) {
    var originalStatus = card.dataset.status || "";
    var openTime = card.dataset.openTime || "";
    var closeTime = card.dataset.closeTime || "";
    var openMinutes = parseTimeMinutes(openTime);
    var closeMinutes = parseTimeMinutes(closeTime);

    if (originalStatus === "coming_soon") {
      return {
        status: "coming_soon",
        label: "Coming Soon",
        helper: ""
      };
    }

    if (openMinutes == null || closeMinutes == null) {
      return {
        status: originalStatus || "closed",
        label: originalStatus === "open" ? "Open Now" : "Closed",
        helper: ""
      };
    }

    if (malaysiaMinutes < openMinutes) {
      return {
        status: "closed",
        label: "Closed",
        helper: "Opens at " + openTime
      };
    }

    if (malaysiaMinutes >= closeMinutes) {
      return {
        status: "closed",
        label: "Closed",
        helper: "Opens at " + openTime
      };
    }

    if (closeMinutes - malaysiaMinutes <= 60) {
      return {
        status: "closing-soon",
        label: "Closing Soon",
        helper: "Closes at " + closeTime
      };
    }

    return {
      status: "open",
      label: "Open Now",
      helper: ""
    };
  }

  function updateLocationStatuses(cards) {
    var malaysiaMinutes = getMalaysiaMinutes();

    cards.forEach(function (card) {
      var result = readLocationStatus(card, malaysiaMinutes);
      var badge = card.querySelector("[data-location-status-badge]");
      var helper = card.querySelector("[data-location-status-helper]");

      card.dataset.currentStatus = result.status;
      card.classList.toggle("is-open-now", result.status === "open");
      card.classList.toggle("is-closing-soon", result.status === "closing-soon");
      card.classList.toggle("is-closed", result.status === "closed");
      card.classList.toggle("is-coming-soon", result.status === "coming_soon");

      if (badge) badge.textContent = result.label;
      if (helper) {
        helper.textContent = result.helper;
        helper.hidden = !result.helper;
      }
    });
  }

  function initExplorer(root) {
    var cards = toArray(root.querySelectorAll("[data-location-card]"));
    var searchInput = root.querySelector("[data-location-search]");
    var buttons = toArray(root.querySelectorAll("[data-location-filter]"));
    var empty = root.querySelector("[data-location-empty]");
    var activeButton = buttons[0] || null;

    function getKeywords(button) {
      return (button && button.dataset.filterKeywords ? button.dataset.filterKeywords : "")
        .split(",")
        .map(function (keyword) {
          return keyword.trim().toLowerCase();
        })
        .filter(Boolean);
    }

    function matchesButtonFilter(card, button) {
      var mode = button && button.dataset.filterMode ? button.dataset.filterMode : "all";
      var status = card.dataset.currentStatus || card.dataset.status || "";

      if (mode === "all") return true;
      if (mode === "open_now") return status === "open" || status === "closing-soon";
      if (mode === "coming_soon") return status === "coming_soon";
      if (mode === "featured") return card.dataset.featured === "true";

      if (mode === "text_match") {
        var keywords = getKeywords(button);
        var haystack = (card.dataset.search || "").toLowerCase();
        if (!keywords.length) return true;
        return keywords.some(function (keyword) {
          return haystack.indexOf(keyword) !== -1;
        });
      }

      return true;
    }

    function updateCounts() {
      buttons.forEach(function (button) {
        if (button.dataset.showCount !== "true") return;
        var countEl = button.querySelector("[data-filter-count]");
        if (!countEl) return;
        var count = cards.filter(function (card) {
          return matchesButtonFilter(card, button);
        }).length;
        countEl.textContent = count;
      });
    }

    function render() {
      var query = searchInput ? searchInput.value.trim().toLowerCase() : "";
      var visibleCount = 0;

      cards.forEach(function (card) {
        var matchesSearch = !query || (card.dataset.search || "").indexOf(query) !== -1;
        var isVisible = matchesSearch && matchesButtonFilter(card, activeButton);
        card.hidden = !isVisible;
        if (isVisible) visibleCount += 1;
      });

      updateCounts();
      if (empty) empty.hidden = visibleCount !== 0;
    }

    buttons.forEach(function (button) {
      button.addEventListener("click", function () {
        activeButton = button;
        buttons.forEach(function (item) {
          item.classList.toggle("is-active", item === button);
        });
        render();
      });
    });

    if (searchInput) {
      searchInput.addEventListener("input", render);
    }

    /*
     * Deep link from the homepage area chips: /pages/locations?area=petaling%20jaya
     *
     * The chips need the filter pre-applied, and the search box already matches against
     * card.dataset.search — which includes the outlet's area — so the cleanest hook is to
     * seed the search input rather than add a parallel filtering path. Area values are
     * stored lowercase-canonical in the template data, so the match is reliable.
     */
    function applyDeepLink() {
      if (!searchInput || typeof window.URLSearchParams !== "function") return;
      var area = new URLSearchParams(window.location.search).get("area");
      if (!area) return;
      searchInput.value = area.trim();
      if (root.scrollIntoView) {
        var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        root.scrollIntoView({ behavior: reduced ? "auto" : "smooth", block: "start" });
      }
    }

    function refreshStatuses() {
      updateLocationStatuses(cards);
      render();
    }

    applyDeepLink();
    refreshStatuses();
    window.setInterval(refreshStatuses, 60000);
  }

  function initVoting(root) {
    var grid = root.querySelector("[data-vote-grid]");
    var initialCards = toArray(root.querySelectorAll("[data-vote-card]"));
    var totalEl = root.querySelector("[data-vote-total]");
    var message = root.querySelector("[data-voted-message]");
    var leaderboard = root.querySelector("[data-vote-leaderboard]");
    var podium = root.querySelector("[data-vote-podium]");
    if (!grid || !initialCards.length) return;

    initialCards.sort(function (a, b) {
      return Number(a.dataset.sortOrder || 0) - Number(b.dataset.sortOrder || 0);
    }).forEach(function (card) {
      grid.appendChild(card);
    });

    var pollKey = root.dataset.pollKey || "dao-our-locations";
    var selectedKey = "dao:locations-voted";
    var legacySelectedKey = "dao:locations:" + pollKey + ":selected";
    var voterSessionId = getSessionId();
    var selected = readJson(selectedKey, null) || readJson(legacySelectedKey, null);
    var liveVotes = {};
    var liveTotal = null;
    var liveLoaded = false;
    var liveUnavailable = false;
    var liveFetchStarted = false;
    var liveCacheKey = "dao:locations:" + pollKey + ":live-results";
    var liveCacheTtl = 60 * 1000;
    var bypassLiveCache = window.location.search.indexOf("freshVotes=1") !== -1;
    var mapPinSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 21s7-5.1 7-11a7 7 0 1 0-14 0c0 5.9 7 11 7 11Z"></path><circle cx="12" cy="10" r="2.5"></circle></svg>';

    function optionFromCard(card) {
      var area = card.dataset.area || "This area";
      var slug = slugify(area);
      card.dataset.optionSlug = slug;
      return {
        id: card.dataset.optionId,
        slug: slug,
        area: area,
        description: card.querySelector("p") ? card.querySelector("p").textContent : "",
        badgeText: card.dataset.badgeText || "",
        startingVotes: Number(card.dataset.startingVotes || 0),
        votes: Number(card.dataset.startingVotes || 0),
        sortOrder: Number(card.dataset.sortOrder || 0),
        card: card
      };
    }

    var fallbackOptions = initialCards.map(optionFromCard);
    var options = fallbackOptions.slice();
    var cards = initialCards.slice();

    function normalizeSelected(value) {
      if (!value) return null;
      var slug = value.option_slug || value.optionSlug || value.slug || slugify(value.area);
      if (!slug && value.id) {
        var matched = options.filter(function (option) {
          return option.id === value.id;
        })[0];
        slug = matched ? matched.slug : "";
      }
      if (!slug) return null;
      var option = options.filter(function (item) {
        return item.slug === slug;
      })[0];
      if (!option) return null;
      return {
        option_slug: slug,
        area: value.area || (option ? option.area : slug),
        at: value.at || new Date().toISOString()
      };
    }

    selected = normalizeSelected(selected);

    function rememberSelected(value) {
      selected = normalizeSelected(value);
      if (selected) writeJson(selectedKey, selected);
    }

    function readVoteCount(item) {
      var value = item.vote_count;
      if (value == null) value = item.votes;
      if (value == null) value = item.count;
      if (value == null) value = item.total_votes;
      if (value == null) value = item.total;
      value = Number(value || 0);
      return Number.isFinite(value) ? value : 0;
    }

    function getPayloadList(payload) {
      if (!payload) return [];
      if (Array.isArray(payload)) return payload;
      if (Array.isArray(payload.results)) return payload.results;
      if (Array.isArray(payload.options)) return payload.options;
      if (Array.isArray(payload.votes)) return payload.votes;
      if (Array.isArray(payload.vote_results)) return payload.vote_results;
      if (Array.isArray(payload.data)) return payload.data;
      if (payload.data && Array.isArray(payload.data.results)) return payload.data.results;
      if (payload.results && typeof payload.results === "object") {
        return Object.keys(payload.results).map(function (slug) {
          return { option_slug: slug, vote_count: payload.results[slug] };
        });
      }
      if (payload.votes && typeof payload.votes === "object") {
        return Object.keys(payload.votes).map(function (slug) {
          return { option_slug: slug, vote_count: payload.votes[slug] };
        });
      }
      return [];
    }

    function numberOrNull(value) {
      if (value == null || value === "") return null;
      value = Number(value);
      return Number.isFinite(value) ? value : null;
    }

    function explicitTotalFromPayload(payload, list) {
      var total = payload && (payload.total_votes != null ? payload.total_votes : (payload.total != null ? payload.total : payload.vote_total));
      total = numberOrNull(total);
      if (total != null) return total;

      for (var index = 0; index < list.length; index += 1) {
        var itemTotal = numberOrNull(list[index].total_votes);
        if (itemTotal != null) return itemTotal;
      }

      return null;
    }

    function optionFromLiveItem(item, index) {
      var area = item.area_name || item.area || item.name || item.label || "";
      var slug = item.slug || item.option_slug || item.optionSlug || slugify(area);
      if (!slug || !area) return null;

      return {
        id: item.id || slug,
        slug: slug,
        area: area,
        description: item.description || item.short_description || "",
        badgeText: item.badge_text || item.badgeText || "",
        startingVotes: 0,
        votes: readVoteCount(item),
        sortOrder: Number(item.sort_order || item.sortOrder || index + 1),
        ranking: Number(item.ranking || index + 1),
        card: null
      };
    }

    function createVoteCard(option) {
      var card = document.createElement("article");
      card.className = "dao-locations-vote-card";
      card.dataset.voteCard = "";
      card.dataset.optionId = option.id;
      card.dataset.optionSlug = option.slug;
      card.dataset.area = option.area;
      card.dataset.badgeText = option.badgeText || "";
      card.dataset.startingVotes = "0";
      card.dataset.sortOrder = option.sortOrder || 0;
      card.innerHTML =
        '<div class="dao-locations-vote-card__top">' +
        '<span class="dao-locations-rank" data-vote-rank>-</span>' +
        '<span class="dao-locations-vote-badge" data-vote-badge></span>' +
        "</div>" +
        "<h3><span aria-hidden=\"true\">" + mapPinSvg + "</span></h3>" +
        "<p></p>" +
        '<div class="dao-locations-vote-card__result">' +
        "<div><strong data-vote-percent>0%</strong><span data-vote-count>0 votes</span></div>" +
        '<div class="dao-locations-progress" aria-hidden="true"><span data-vote-progress></span></div>' +
        "</div>" +
        '<button type="button" data-vote-button>Vote for this area</button>';
      card.querySelector("h3").appendChild(document.createTextNode(option.area));
      card.querySelector("p").textContent = option.description || "";
      return card;
    }

    function renderVoteCardsFromOptions() {
      grid.innerHTML = "";
      cards = options.map(function (option) {
        var card = option.card || createVoteCard(option);
        option.card = card;
        grid.appendChild(card);
        return card;
      });
    }

    function applyLivePayload(payload) {
      var list = getPayloadList(payload);
      var liveOptions = list.map(optionFromLiveItem).filter(Boolean);

      if (!liveOptions.length) {
        return false;
      }

      liveOptions.sort(function (a, b) {
        return a.sortOrder - b.sortOrder;
      });

      options = liveOptions;
      renderVoteCardsFromOptions();
      liveVotes = {};
      liveOptions.forEach(function (option) {
        liveVotes[option.slug] = option.votes;
      });
      liveLoaded = true;
      liveUnavailable = false;

      var explicitTotal = explicitTotalFromPayload(payload, list);
      liveTotal = explicitTotal != null ? explicitTotal : liveOptions.reduce(function (sum, option) {
        return sum + option.votes;
      }, 0);

      var votedSlug = payload && (
        payload.option_slug ||
        payload.optionSlug ||
        payload.selected_option_slug ||
        payload.selectedOptionSlug ||
        (payload.vote && (payload.vote.option_slug || payload.vote.slug))
      );

      if (payload && (payload.voted || payload.already_voted || votedSlug)) {
        rememberSelected({
          option_slug: votedSlug || (selected && selected.option_slug),
          at: new Date().toISOString()
        });
      }

      selected = normalizeSelected(selected);
      return true;
    }

    function readCachedLiveResults() {
      if (bypassLiveCache) return false;
      var cached = readSessionJson(liveCacheKey, null);
      if (!cached || !cached.payload || !cached.cachedAt) return false;
      if (Date.now() - Number(cached.cachedAt) > liveCacheTtl) return false;
      applyLivePayload(cached.payload);
      return liveLoaded;
    }

    function cacheLiveResults(payload) {
      writeSessionJson(liveCacheKey, {
        cachedAt: Date.now(),
        payload: payload
      });
    }

    function fetchLiveResults(options) {
      options = options || {};
      if (liveFetchStarted && !options.force) return;
      liveFetchStarted = true;

      if (!options.force && readCachedLiveResults()) {
        render();
        return;
      }

      if (!window.fetch) {
        liveUnavailable = true;
        render("Live voting is temporarily unavailable. Please try again later.");
        return;
      }

      fetch(liveVotingEndpoint, {
        method: "GET",
        headers: liveVotingHeaders()
      })
        .then(function (response) {
          if (!response.ok) throw new Error("Vote results request failed");
          return response.json();
        })
        .then(function (payload) {
          applyLivePayload(payload);
          cacheLiveResults(payload);
          render();
        })
        .catch(function () {
          liveUnavailable = true;
          render("Live voting is temporarily unavailable. Please try again later.");
        })
        .finally(function () {
          if (options.force) liveFetchStarted = false;
        });
    }

    function loadLiveResultsWhenReady() {
      var voteSection = root.querySelector("#dao-locations-vote") || grid;

      if (readCachedLiveResults()) {
        render();
        return;
      }

      if (!("IntersectionObserver" in window) || !voteSection) {
        fetchLiveResults();
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            observer.disconnect();
            fetchLiveResults();
          }
        });
      }, { rootMargin: "420px 0px", threshold: 0.01 });

      observer.observe(voteSection);
    }

    function getOptionalVotePayload() {
      var payload = {};
      [
        ["voter_name", "[name='voter_name'], [name='contact[name]'], [data-vote-voter-name]"],
        ["voter_email", "[name='voter_email'], [name='contact[email]'], [data-vote-voter-email]"],
        ["voter_phone", "[name='voter_phone'], [name='contact[phone]'], [data-vote-voter-phone]"],
        ["suggested_mall", "[name='suggested_mall'], [data-vote-suggested-mall]"],
        ["note", "[name='note'], [name='contact[body]'], [data-vote-note]"]
      ].forEach(function (item) {
        var field = root.querySelector(item[1]);
        if (field && field.value && field.value.trim()) {
          payload[item[0]] = field.value.trim();
        }
      });
      return payload;
    }

    function getResults() {
      var results = options.map(function (option) {
        var votes = liveLoaded ? option.votes : option.startingVotes;
        return {
          id: option.id,
          slug: option.slug,
          area: option.area,
          votes: Number(votes || 0),
          card: option.card
        };
      });

      var computedTotal = results.reduce(function (sum, item) {
        return sum + item.votes;
      }, 0);
      var total = liveTotal != null && liveTotal >= 0 ? liveTotal : computedTotal;
      var percentTotal = total > 0 ? total : 1;

      results.sort(function (a, b) {
        return b.votes - a.votes;
      });

      results.forEach(function (item, index) {
        item.rank = index + 1;
        item.percent = (item.votes / percentTotal) * 100;
        item.isLeading = total > 0 && item.votes > 0 && index === 0;
        item.isSelected = selected && selected.option_slug === item.slug;
      });

      return { results: results, total: total };
    }

    function updateCards(data) {
      data.results.forEach(function (item) {
        var card = item.card;
        var rank = card.querySelector("[data-vote-rank]");
        var count = card.querySelector("[data-vote-count]");
        var percent = card.querySelector("[data-vote-percent]");
        var progress = card.querySelector("[data-vote-progress]");
        var button = card.querySelector("[data-vote-button]");
        var badge = card.querySelector("[data-vote-badge]");

        card.classList.toggle("is-leading", item.isLeading);
        card.classList.toggle("is-voted", item.isSelected);

        if (rank) rank.textContent = item.rank;
        if (count) count.textContent = formatNumber(item.votes) + " votes";
        if (percent) percent.textContent = formatPercent(item.percent);
        if (progress) progress.style.width = item.percent + "%";

        if (badge) {
          var badgeText = card.dataset.badgeText || "";
          badge.textContent = item.isLeading ? (badgeText || "Leading") : badgeText;
        }

        if (button) {
          button.disabled = !!selected;
          button.classList.toggle("is-selected", item.isSelected);
          if (item.isSelected) {
            button.textContent = "Your Vote";
          } else if (selected) {
            button.textContent = "Already voted";
          } else {
            button.textContent = "Vote for this area";
          }
        }
      });

      if (totalEl) {
        totalEl.textContent = " " + formatNumber(data.total) + " live fan votes.";
      }

      if (message) {
        if (selected && selected.area) {
          message.hidden = false;
          message.textContent = "You voted for " + selected.area + ". Thanks for helping us plan where DAO should grow next.";
        } else if (liveUnavailable) {
          message.hidden = false;
          message.textContent = "Live voting is temporarily unavailable. Please try again later.";
        } else if (liveLoaded && data.total === 0) {
          message.hidden = false;
          message.textContent = "Waiting for the first votes.";
        } else {
          message.hidden = true;
          message.textContent = "";
        }
      }
    }

    function renderPodium(results, total) {
      if (!podium) return;
      if (total <= 0) {
        podium.innerHTML = '<p class="dao-locations-empty">Waiting for the first votes.</p>';
        return;
      }
      var order = [results[1], results[0], results[2]];
      var labels = ["2nd", "1st", "3rd"];
      podium.innerHTML = "";

      order.forEach(function (item, index) {
        if (!item) return;
        var card = document.createElement("article");
        card.className = "dao-locations-podium-card" + (index === 1 ? " is-first" : "");
        card.innerHTML =
          '<div class="dao-locations-podium-card__top">' +
          "<small>" + labels[index] + "</small>" +
          "<strong></strong>" +
          "<span></span>" +
          "</div>" +
          '<div class="dao-locations-podium-card__base" aria-hidden="true">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M8 21h8"/><path d="M12 17v4"/><path d="M7 4h10v4a5 5 0 0 1-10 0V4Z"/><path d="M5 5H3v2a4 4 0 0 0 4 4"/><path d="M19 5h2v2a4 4 0 0 1-4 4"/></svg>' +
          "</div>";
        card.querySelector("strong").textContent = item.area;
        card.querySelector("span").textContent = formatPercent(item.percent);
        podium.appendChild(card);
      });
    }

    function renderLeaderboard(results) {
      if (!leaderboard) return;
      leaderboard.innerHTML = "";

      results.slice(3).forEach(function (item) {
        var row = document.createElement("div");
        row.className = "dao-locations-leaderboard-row";
        row.innerHTML =
          '<div class="dao-locations-leaderboard-row__rank"></div>' +
          "<div><strong></strong><div class=\"dao-locations-leaderboard-row__bar\"><span></span></div></div>" +
          '<div class="dao-locations-leaderboard-row__meta"></div>';
        row.querySelector(".dao-locations-leaderboard-row__rank").textContent = item.rank;
        row.querySelector("strong").textContent = item.area;
        row.querySelector(".dao-locations-leaderboard-row__bar span").style.width = item.percent + "%";
        row.querySelector(".dao-locations-leaderboard-row__meta").textContent = formatNumber(item.votes) + " / " + formatPercent(item.percent);
        leaderboard.appendChild(row);
      });
    }

    function render(statusMessage) {
      var data = getResults();
      updateCards(data);
      renderPodium(data.results, data.total);
      renderLeaderboard(data.results);

      if (statusMessage && message) {
        message.hidden = false;
        message.textContent = statusMessage;
      }
    }

    grid.addEventListener("click", function (event) {
      var button = event.target.closest("[data-vote-button]");
      if (!button) return;
      var card = button.closest("[data-vote-card]");
      if (!card) return;

      if (selected) {
        render("You've already voted on this device.");
        return;
      }
      if (!window.fetch) {
        liveUnavailable = true;
        render("Live voting is temporarily unavailable. Please try again later.");
        return;
      }
      var slug = card.dataset.optionSlug || slugify(card.dataset.area);
      var area = card.dataset.area || "this area";
      button.disabled = true;
      button.textContent = "Sending...";

      var body = {
        option_slug: slug,
        voter_session_id: voterSessionId,
        page_url: window.location.href
      };
      var optionalPayload = getOptionalVotePayload();
      Object.keys(optionalPayload).forEach(function (key) {
        body[key] = optionalPayload[key];
      });

      fetch(liveVotingEndpoint, {
        method: "POST",
        headers: liveVotingHeaders(),
        body: JSON.stringify(body)
      })
        .then(function (response) {
          return response.json().catch(function () {
            return {};
          }).then(function (payload) {
            if (!response.ok && !payload.already_voted) throw new Error("Vote request failed");
            return payload;
          });
        })
        .then(function (payload) {
          applyLivePayload(payload);
          rememberSelected({
            option_slug: payload.option_slug || payload.selected_option_slug || slug,
            area: area,
            at: new Date().toISOString()
          });
          render(payload.already_voted ? "You've already voted on this device." : "Thanks for voting. Live fan votes have been updated.");
          fetchLiveResults({ force: true });
        })
        .catch(function () {
          liveUnavailable = true;
          button.disabled = false;
          render("Live voting is temporarily unavailable. Please try again later.");
        });
    });

    render();
    loadLiveResultsWhenReady();
  }

  function init(root) {
    if (!root || root.dataset.daoLocationsInit === "true") return;
    root.dataset.daoLocationsInit = "true";
    initReveals(root);
    initExplorer(root);
    initVoting(root);
  }

  document.addEventListener("DOMContentLoaded", function () {
    toArray(document.querySelectorAll("[data-dao-locations-root]")).forEach(init);
  });

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target.querySelector("[data-dao-locations-root]"));
  });
})();
